export default __webpack_public_path__ + "assets/images/8121ede62c04fd3c1fac25e7e08960a1.png";